"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderProgressionApi = exports.OrderProgressionApiFactory = exports.OrderProgressionApiFp = exports.OrderProgressionApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * OrderProgressionApi - axios parameter creator
 * @export
 */
var OrderProgressionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
         * @summary Archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('archivePolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}/archive"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a new draft of the policy
         * @summary Creates a new version in draft mode from a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDraftPolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('cloneDraftPolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}/new-version-draft"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Confirms the indication and its attributes
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmIndicationFromOrderProgressionController: function (indicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationId' is not null or undefined
                            (0, common_1.assertParamExists)('confirmIndicationFromOrderProgressionController', 'indicationId', indicationId);
                            localVarPath = "/order-progression/indications/{indicationId}/confirm-derived-models"
                                .replace("{".concat("indicationId", "}"), encodeURIComponent(String(indicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Confirms the relative and child models
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRelativeFromOrderProgressionController: function (relativeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'relativeId' is not null or undefined
                            (0, common_1.assertParamExists)('confirmRelativeFromOrderProgressionController', 'relativeId', relativeId);
                            localVarPath = "/order-progression/relatives/{relativeId}/confirm-derived-models"
                                .replace("{".concat("relativeId", "}"), encodeURIComponent(String(relativeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {OpsNewAttributeConfigRequestObjectDto} opsNewAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributeConfigFromOrderProgressionController: function (opsNewAttributeConfigRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'opsNewAttributeConfigRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('createAttributeConfigFromOrderProgressionController', 'opsNewAttributeConfigRequestObjectDto', opsNewAttributeConfigRequestObjectDto);
                            localVarPath = "/order-progression/attribute-configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsNewAttributeConfigRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {OpsNewIndicationConfigRequestObjectDto} opsNewIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndicationConfigFromOrderProgressionController: function (opsNewIndicationConfigRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'opsNewIndicationConfigRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('createIndicationConfigFromOrderProgressionController', 'opsNewIndicationConfigRequestObjectDto', opsNewIndicationConfigRequestObjectDto);
                            localVarPath = "/order-progression/indication-configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsNewIndicationConfigRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new policy record for meeting medical necessity
         * @summary Creates a new policy
         * @param {OpsNewPolicyRequestObjectDto} opsNewPolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyFromOrderProgressionController: function (opsNewPolicyRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'opsNewPolicyRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('createPolicyFromOrderProgressionController', 'opsNewPolicyRequestObjectDto', opsNewPolicyRequestObjectDto);
                            localVarPath = "/order-progression/policies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsNewPolicyRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a new rule for the given policy
         * @summary Creates a new rule for a policy
         * @param {number} policyId
         * @param {OpsNewRuleRequestObjectDto} opsNewRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyRuleFromOrderProgressionController: function (policyId, opsNewRuleRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('createPolicyRuleFromOrderProgressionController', 'policyId', policyId);
                            // verify required parameter 'opsNewRuleRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('createPolicyRuleFromOrderProgressionController', 'opsNewRuleRequestObjectDto', opsNewRuleRequestObjectDto);
                            localVarPath = "/order-progression/policies/{policyId}/rules"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsNewRuleRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication attribute configuration
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'attributeConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAttributeConfigFromOrderProgressionController', 'attributeConfigId', attributeConfigId);
                            localVarPath = "/order-progression/attribute-configs/{attributeConfigId}"
                                .replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(attributeConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication attribute
         * @param {number} attributeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationAttributeFromOrderProgressionController: function (attributeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'attributeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteIndicationAttributeFromOrderProgressionController', 'attributeId', attributeId);
                            localVarPath = "/order-progression/indication-attributes/{attributeId}"
                                .replace("{".concat("attributeId", "}"), encodeURIComponent(String(attributeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication configuration
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteIndicationConfigFromOrderProgressionController', 'indicationConfigId', indicationConfigId);
                            localVarPath = "/order-progression/indication-configs/{indicationConfigId}"
                                .replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(indicationConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationFromOrderProgressionController: function (indicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteIndicationFromOrderProgressionController', 'indicationId', indicationId);
                            localVarPath = "/order-progression/indications/{indicationId}"
                                .replace("{".concat("indicationId", "}"), encodeURIComponent(String(indicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This deletes the policy is_draft=True, is_active=False
         * @summary DELETES a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a relative by id
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelativeFromOrderProgressionController: function (relativeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'relativeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRelativeFromOrderProgressionController', 'relativeId', relativeId);
                            localVarPath = "/order-progression/relatives/{relativeId}"
                                .replace("{".concat("relativeId", "}"), encodeURIComponent(String(relativeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} force
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRqFromOrderProgressionController: function (rqid, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRqFromOrderProgressionController', 'rqid', rqid);
                            // verify required parameter 'force' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRqFromOrderProgressionController', 'force', force);
                            localVarPath = "/order-progression/requisitions/{rqid}"
                                .replace("{".concat("rqid", "}"), encodeURIComponent(String(rqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a medical necessity rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleFromOrderProgressionController: function (ruleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRuleFromOrderProgressionController', 'ruleId', ruleId);
                            localVarPath = "/order-progression/medical-necessity-rules/{ruleId}"
                                .replace("{".concat("ruleId", "}"), encodeURIComponent(String(ruleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a indication attribute configuration by id
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'attributeConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('getAttributeConfigFromOrderProgressionController', 'attributeConfigId', attributeConfigId);
                            localVarPath = "/order-progression/attribute-configs/{attributeConfigId}"
                                .replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(attributeConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Available indications attribute definitions
         * @summary Returns a list indication attribute configurations for the indication
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/attribute-configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['orderBy'] = orderBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of available cpts for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCptsFromOrderProgressionController: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/cpts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a indication configuration by id
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('getIndicationConfigFromOrderProgressionController', 'indicationConfigId', indicationConfigId);
                            localVarPath = "/order-progression/indication-configs/{indicationConfigId}"
                                .replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(indicationConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list indication names with configurations
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/indication-configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['orderBy'] = orderBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of indications with matching names, and a list of options with matching option names
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsWithRelatedOptionsFromOrderProgressionController: function (query, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'query' is not null or undefined
                            (0, common_1.assertParamExists)('getIndicationConfigsWithRelatedOptionsFromOrderProgressionController', 'query', query);
                            localVarPath = "/order-progression/indication-configs/options/configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most recently edited timestamps and user emails.
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEditorsFromOrderProgressionController: function (rqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('getLastEditorsFromOrderProgressionController', 'rqid', rqid);
                            localVarPath = "/order-progression/requisitions/{rqid}/audits-last-editors"
                                .replace("{".concat("rqid", "}"), encodeURIComponent(String(rqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a medical necessity rule given an id
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalNecessityRuleFromOrderProgressionController: function (ruleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('getMedicalNecessityRuleFromOrderProgressionController', 'ruleId', ruleId);
                            localVarPath = "/order-progression/medical-necessity-rules/{ruleId}"
                                .replace("{".concat("ruleId", "}"), encodeURIComponent(String(ruleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
         * @summary Returns a list of policies along with the pagination info for the query
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoliciesFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/policies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['orderBy'] = orderBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('getPolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List of available primary indication names used by backoffice/portal
         * @summary Returns a list of primary indications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryIndicationNamesFromOrderProgressionController: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/primary-indications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns lineage options and relationship type options with configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelativeConfigsFromOrderProgressionController: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/order-progression/relative-configs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} [plan]
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [userEmail] the email of the user that initially loaded in the Requisition or the last user to edit anything related
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqFromOrderProgressionController: function (rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('getRqFromOrderProgressionController', 'rqid', rqid);
                            localVarPath = "/order-progression/requisitions/{rqid}"
                                .replace("{".concat("rqid", "}"), encodeURIComponent(String(rqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (plan !== undefined) {
                                localVarQueryParameter['plan'] = plan;
                            }
                            if (allowUnconfirmedFields !== undefined) {
                                localVarQueryParameter['allowUnconfirmedFields'] = allowUnconfirmedFields;
                            }
                            if (userEmail !== undefined) {
                                localVarQueryParameter['userEmail'] = userEmail;
                            }
                            if (useInsurancePolicies !== undefined) {
                                localVarQueryParameter['useInsurancePolicies'] = useInsurancePolicies;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns an LMN generated attachment object model for an rq given a met rule id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqLmnAttachmentForMetRuleFromOrderProgressionController: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getRqLmnAttachmentForMetRuleFromOrderProgressionController', 'id', id);
                            localVarPath = "/order-progression/requisitions/{id}/mn-rule-attachment"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
         * @summary Returns a satisfied policy for the given requisition\'s current state, if one exists
         * @param {number} id
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqSatisfiedPolicyFromOrderProgressionController: function (id, useInsurancePolicies, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getRqSatisfiedPolicyFromOrderProgressionController', 'id', id);
                            localVarPath = "/order-progression/requisitions/{id}/satisfied-policy"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (useInsurancePolicies !== undefined) {
                                localVarQueryParameter['useInsurancePolicies'] = useInsurancePolicies;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {number} attributeConfigId
         * @param {OpsPatchAttributeConfigRequestObjectDto} opsPatchAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAttributeConfigFromOrderProgressionController: function (attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'attributeConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAttributeConfigFromOrderProgressionController', 'attributeConfigId', attributeConfigId);
                            // verify required parameter 'opsPatchAttributeConfigRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchAttributeConfigFromOrderProgressionController', 'opsPatchAttributeConfigRequestObjectDto', opsPatchAttributeConfigRequestObjectDto);
                            localVarPath = "/order-progression/attribute-configs/{attributeConfigId}"
                                .replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(attributeConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchAttributeConfigRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {number} indicationConfigId
         * @param {OpsPatchIndicationConfigRequestObjectDto} opsPatchIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIndicationConfigFromOrderProgressionController: function (indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('patchIndicationConfigFromOrderProgressionController', 'indicationConfigId', indicationConfigId);
                            // verify required parameter 'opsPatchIndicationConfigRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchIndicationConfigFromOrderProgressionController', 'opsPatchIndicationConfigRequestObjectDto', opsPatchIndicationConfigRequestObjectDto);
                            localVarPath = "/order-progression/indication-configs/{indicationConfigId}"
                                .replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(indicationConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchIndicationConfigRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Patch a proband
         * @param {number} probandId
         * @param {OpsPatchProbandRequestObjectDto} opsPatchProbandRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProbandFromOrderProgressionController: function (probandId, opsPatchProbandRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'probandId' is not null or undefined
                            (0, common_1.assertParamExists)('patchProbandFromOrderProgressionController', 'probandId', probandId);
                            // verify required parameter 'opsPatchProbandRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchProbandFromOrderProgressionController', 'opsPatchProbandRequestObjectDto', opsPatchProbandRequestObjectDto);
                            localVarPath = "/order-progression/probands/{probandId}"
                                .replace("{".concat("probandId", "}"), encodeURIComponent(String(probandId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchProbandRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary answer a planner question, patches requisition object
         * @param {number} id
         * @param {OpsQuestionAnswerRequestDto} opsQuestionAnswerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionAnswerFromOrderProgressionController: function (id, opsQuestionAnswerRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('patchQuestionAnswerFromOrderProgressionController', 'id', id);
                            // verify required parameter 'opsQuestionAnswerRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchQuestionAnswerFromOrderProgressionController', 'opsQuestionAnswerRequestDto', opsQuestionAnswerRequestDto);
                            localVarPath = "/order-progression/requisitions/{id}/question-answer"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsQuestionAnswerRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Patch a relative
         * @param {number} relativeId
         * @param {OpsPatchRelativeRequestObjectDto} opsPatchRelativeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRelativeFromOrderProgressionController: function (relativeId, opsPatchRelativeRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'relativeId' is not null or undefined
                            (0, common_1.assertParamExists)('patchRelativeFromOrderProgressionController', 'relativeId', relativeId);
                            // verify required parameter 'opsPatchRelativeRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchRelativeFromOrderProgressionController', 'opsPatchRelativeRequestObjectDto', opsPatchRelativeRequestObjectDto);
                            localVarPath = "/order-progression/relatives/{relativeId}"
                                .replace("{".concat("relativeId", "}"), encodeURIComponent(String(relativeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchRelativeRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
         * @summary Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqCheckForUpdatesFromOrderProgressionController: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('patchRqCheckForUpdatesFromOrderProgressionController', 'id', id);
                            localVarPath = "/order-progression/requisitions/{id}/check-for-updates"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
         * @param {number} id
         * @param {OpsPatchRequisitionRequestDto} opsPatchRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqFromOrderProgressionController: function (id, opsPatchRequisitionRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('patchRqFromOrderProgressionController', 'id', id);
                            // verify required parameter 'opsPatchRequisitionRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchRqFromOrderProgressionController', 'opsPatchRequisitionRequestDto', opsPatchRequisitionRequestDto);
                            localVarPath = "/order-progression/requisitions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchRequisitionRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
         * @summary Patches a medical necessity rule and relational definitions
         * @param {number} ruleId
         * @param {OpsPatchRuleRequestObjectDto} opsPatchRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRuleFromOrderProgressionController: function (ruleId, opsPatchRuleRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('patchRuleFromOrderProgressionController', 'ruleId', ruleId);
                            // verify required parameter 'opsPatchRuleRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchRuleFromOrderProgressionController', 'opsPatchRuleRequestObjectDto', opsPatchRuleRequestObjectDto);
                            localVarPath = "/order-progression/medical-necessity-rules/{ruleId}"
                                .replace("{".concat("ruleId", "}"), encodeURIComponent(String(ruleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsPatchRuleRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new attribute for an indication
         * @param {number} indicationId
         * @param {OpsCreateIndicationAttributeRequestObjectDto} opsCreateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIndicationAttributeFromOrderProgressionController: function (indicationId, opsCreateIndicationAttributeRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationId' is not null or undefined
                            (0, common_1.assertParamExists)('postIndicationAttributeFromOrderProgressionController', 'indicationId', indicationId);
                            // verify required parameter 'opsCreateIndicationAttributeRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('postIndicationAttributeFromOrderProgressionController', 'opsCreateIndicationAttributeRequestObjectDto', opsCreateIndicationAttributeRequestObjectDto);
                            localVarPath = "/order-progression/indications/{indicationId}/attributes"
                                .replace("{".concat("indicationId", "}"), encodeURIComponent(String(indicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsCreateIndicationAttributeRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an indication for a proband
         * @param {number} probandId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProbandIndicationFromOrderProgressionController: function (probandId, opsCreateIndicationRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'probandId' is not null or undefined
                            (0, common_1.assertParamExists)('postProbandIndicationFromOrderProgressionController', 'probandId', probandId);
                            // verify required parameter 'opsCreateIndicationRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('postProbandIndicationFromOrderProgressionController', 'opsCreateIndicationRequestObjectDto', opsCreateIndicationRequestObjectDto);
                            localVarPath = "/order-progression/probands/{probandId}/indications"
                                .replace("{".concat("probandId", "}"), encodeURIComponent(String(probandId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsCreateIndicationRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new relative for a proband
         * @param {number} probandId
         * @param {OpsCreateRelativeRequestDto} opsCreateRelativeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeForProbandFromOrderProgressionController: function (probandId, opsCreateRelativeRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'probandId' is not null or undefined
                            (0, common_1.assertParamExists)('postRelativeForProbandFromOrderProgressionController', 'probandId', probandId);
                            // verify required parameter 'opsCreateRelativeRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('postRelativeForProbandFromOrderProgressionController', 'opsCreateRelativeRequestDto', opsCreateRelativeRequestDto);
                            localVarPath = "/order-progression/probands/{probandId}/relatives"
                                .replace("{".concat("probandId", "}"), encodeURIComponent(String(probandId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsCreateRelativeRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an indication for a relative
         * @param {number} relativeId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeIndicationFromOrderProgressionController: function (relativeId, opsCreateIndicationRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'relativeId' is not null or undefined
                            (0, common_1.assertParamExists)('postRelativeIndicationFromOrderProgressionController', 'relativeId', relativeId);
                            // verify required parameter 'opsCreateIndicationRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('postRelativeIndicationFromOrderProgressionController', 'opsCreateIndicationRequestObjectDto', opsCreateIndicationRequestObjectDto);
                            localVarPath = "/order-progression/relatives/{relativeId}/indications"
                                .replace("{".concat("relativeId", "}"), encodeURIComponent(String(relativeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsCreateIndicationRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
         * @summary Finalizes the derived models for a requisition
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRqConfirmDerivedModelsFromOrderProgressionController: function (rqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('postRqConfirmDerivedModelsFromOrderProgressionController', 'rqid', rqid);
                            localVarPath = "/order-progression/requisitions/{rqid}/confirm-derived-models"
                                .replace("{".concat("rqid", "}"), encodeURIComponent(String(rqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
         * @summary PUBLISH a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('publishPolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}/publish"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an indication attribute
         * @param {number} attributeId
         * @param {OpsUpdateIndicationAttributeRequestObjectDto} opsUpdateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationAttributeFromOrderProgressionController: function (attributeId, opsUpdateIndicationAttributeRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'attributeId' is not null or undefined
                            (0, common_1.assertParamExists)('putIndicationAttributeFromOrderProgressionController', 'attributeId', attributeId);
                            // verify required parameter 'opsUpdateIndicationAttributeRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('putIndicationAttributeFromOrderProgressionController', 'opsUpdateIndicationAttributeRequestObjectDto', opsUpdateIndicationAttributeRequestObjectDto);
                            localVarPath = "/order-progression/indication-attributes/{attributeId}"
                                .replace("{".concat("attributeId", "}"), encodeURIComponent(String(attributeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsUpdateIndicationAttributeRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an indication
         * @param {number} indicationId
         * @param {OpsUpdateIndicationRequestObjectDto} opsUpdateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationFromOrderProgressionController: function (indicationId, opsUpdateIndicationRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'indicationId' is not null or undefined
                            (0, common_1.assertParamExists)('putIndicationFromOrderProgressionController', 'indicationId', indicationId);
                            // verify required parameter 'opsUpdateIndicationRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('putIndicationFromOrderProgressionController', 'opsUpdateIndicationRequestObjectDto', opsUpdateIndicationRequestObjectDto);
                            localVarPath = "/order-progression/indications/{indicationId}"
                                .replace("{".concat("indicationId", "}"), encodeURIComponent(String(indicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsUpdateIndicationRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
         * @summary Un-archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchivePolicyFromOrderProgressionController: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('unarchivePolicyFromOrderProgressionController', 'policyId', policyId);
                            localVarPath = "/order-progression/policies/{policyId}/unarchive"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates a policy and returns the updated policy
         * @summary Updates a policy given the request object data
         * @param {number} policyId
         * @param {OpsUpdatePolicyRequestObjectDto} opsUpdatePolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyFromOrderProgressionController: function (policyId, opsUpdatePolicyRequestObjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePolicyFromOrderProgressionController', 'policyId', policyId);
                            // verify required parameter 'opsUpdatePolicyRequestObjectDto' is not null or undefined
                            (0, common_1.assertParamExists)('updatePolicyFromOrderProgressionController', 'opsUpdatePolicyRequestObjectDto', opsUpdatePolicyRequestObjectDto);
                            localVarPath = "/order-progression/policies/{policyId}"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(opsUpdatePolicyRequestObjectDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrderProgressionApiAxiosParamCreator = OrderProgressionApiAxiosParamCreator;
/**
 * OrderProgressionApi - functional programming interface
 * @export
 */
var OrderProgressionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrderProgressionApiAxiosParamCreator)(configuration);
    return {
        /**
         * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
         * @summary Archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.archivePolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a new draft of the policy
         * @summary Creates a new version in draft mode from a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDraftPolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cloneDraftPolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Confirms the indication and its attributes
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmIndicationFromOrderProgressionController: function (indicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.confirmIndicationFromOrderProgressionController(indicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Confirms the relative and child models
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRelativeFromOrderProgressionController: function (relativeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.confirmRelativeFromOrderProgressionController(relativeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {OpsNewAttributeConfigRequestObjectDto} opsNewAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributeConfigFromOrderProgressionController: function (opsNewAttributeConfigRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAttributeConfigFromOrderProgressionController(opsNewAttributeConfigRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {OpsNewIndicationConfigRequestObjectDto} opsNewIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndicationConfigFromOrderProgressionController: function (opsNewIndicationConfigRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createIndicationConfigFromOrderProgressionController(opsNewIndicationConfigRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new policy record for meeting medical necessity
         * @summary Creates a new policy
         * @param {OpsNewPolicyRequestObjectDto} opsNewPolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyFromOrderProgressionController: function (opsNewPolicyRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPolicyFromOrderProgressionController(opsNewPolicyRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a new rule for the given policy
         * @summary Creates a new rule for a policy
         * @param {number} policyId
         * @param {OpsNewRuleRequestObjectDto} opsNewRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyRuleFromOrderProgressionController: function (policyId, opsNewRuleRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPolicyRuleFromOrderProgressionController(policyId, opsNewRuleRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication attribute configuration
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAttributeConfigFromOrderProgressionController(attributeConfigId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication attribute
         * @param {number} attributeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationAttributeFromOrderProgressionController: function (attributeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIndicationAttributeFromOrderProgressionController(attributeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication configuration
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIndicationConfigFromOrderProgressionController(indicationConfigId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an indication
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationFromOrderProgressionController: function (indicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIndicationFromOrderProgressionController(indicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This deletes the policy is_draft=True, is_active=False
         * @summary DELETES a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a relative by id
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelativeFromOrderProgressionController: function (relativeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRelativeFromOrderProgressionController(relativeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} force
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRqFromOrderProgressionController: function (rqid, force, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRqFromOrderProgressionController(rqid, force, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a medical necessity rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleFromOrderProgressionController: function (ruleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRuleFromOrderProgressionController(ruleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a indication attribute configuration by id
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttributeConfigFromOrderProgressionController(attributeConfigId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available indications attribute definitions
         * @summary Returns a list indication attribute configurations for the indication
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttributeConfigsFromOrderProgressionController(page, limit, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of available cpts for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCptsFromOrderProgressionController: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCptsFromOrderProgressionController(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a indication configuration by id
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIndicationConfigFromOrderProgressionController(indicationConfigId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list indication names with configurations
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIndicationConfigsFromOrderProgressionController(page, limit, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of indications with matching names, and a list of options with matching option names
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsWithRelatedOptionsFromOrderProgressionController: function (query, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIndicationConfigsWithRelatedOptionsFromOrderProgressionController(query, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most recently edited timestamps and user emails.
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEditorsFromOrderProgressionController: function (rqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLastEditorsFromOrderProgressionController(rqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a medical necessity rule given an id
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalNecessityRuleFromOrderProgressionController: function (ruleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMedicalNecessityRuleFromOrderProgressionController(ruleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
         * @summary Returns a list of policies along with the pagination info for the query
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoliciesFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPoliciesFromOrderProgressionController(page, limit, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List of available primary indication names used by backoffice/portal
         * @summary Returns a list of primary indications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryIndicationNamesFromOrderProgressionController: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPrimaryIndicationNamesFromOrderProgressionController(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns lineage options and relationship type options with configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelativeConfigsFromOrderProgressionController: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRelativeConfigsFromOrderProgressionController(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} [plan]
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [userEmail] the email of the user that initially loaded in the Requisition or the last user to edit anything related
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqFromOrderProgressionController: function (rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRqFromOrderProgressionController(rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns an LMN generated attachment object model for an rq given a met rule id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqLmnAttachmentForMetRuleFromOrderProgressionController: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRqLmnAttachmentForMetRuleFromOrderProgressionController(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
         * @summary Returns a satisfied policy for the given requisition\'s current state, if one exists
         * @param {number} id
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqSatisfiedPolicyFromOrderProgressionController: function (id, useInsurancePolicies, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRqSatisfiedPolicyFromOrderProgressionController(id, useInsurancePolicies, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {number} attributeConfigId
         * @param {OpsPatchAttributeConfigRequestObjectDto} opsPatchAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAttributeConfigFromOrderProgressionController: function (attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAttributeConfigFromOrderProgressionController(attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {number} indicationConfigId
         * @param {OpsPatchIndicationConfigRequestObjectDto} opsPatchIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIndicationConfigFromOrderProgressionController: function (indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchIndicationConfigFromOrderProgressionController(indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Patch a proband
         * @param {number} probandId
         * @param {OpsPatchProbandRequestObjectDto} opsPatchProbandRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProbandFromOrderProgressionController: function (probandId, opsPatchProbandRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchProbandFromOrderProgressionController(probandId, opsPatchProbandRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary answer a planner question, patches requisition object
         * @param {number} id
         * @param {OpsQuestionAnswerRequestDto} opsQuestionAnswerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionAnswerFromOrderProgressionController: function (id, opsQuestionAnswerRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchQuestionAnswerFromOrderProgressionController(id, opsQuestionAnswerRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Patch a relative
         * @param {number} relativeId
         * @param {OpsPatchRelativeRequestObjectDto} opsPatchRelativeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRelativeFromOrderProgressionController: function (relativeId, opsPatchRelativeRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRelativeFromOrderProgressionController(relativeId, opsPatchRelativeRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
         * @summary Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqCheckForUpdatesFromOrderProgressionController: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRqCheckForUpdatesFromOrderProgressionController(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
         * @param {number} id
         * @param {OpsPatchRequisitionRequestDto} opsPatchRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqFromOrderProgressionController: function (id, opsPatchRequisitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRqFromOrderProgressionController(id, opsPatchRequisitionRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
         * @summary Patches a medical necessity rule and relational definitions
         * @param {number} ruleId
         * @param {OpsPatchRuleRequestObjectDto} opsPatchRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRuleFromOrderProgressionController: function (ruleId, opsPatchRuleRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRuleFromOrderProgressionController(ruleId, opsPatchRuleRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new attribute for an indication
         * @param {number} indicationId
         * @param {OpsCreateIndicationAttributeRequestObjectDto} opsCreateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIndicationAttributeFromOrderProgressionController: function (indicationId, opsCreateIndicationAttributeRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postIndicationAttributeFromOrderProgressionController(indicationId, opsCreateIndicationAttributeRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an indication for a proband
         * @param {number} probandId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProbandIndicationFromOrderProgressionController: function (probandId, opsCreateIndicationRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postProbandIndicationFromOrderProgressionController(probandId, opsCreateIndicationRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new relative for a proband
         * @param {number} probandId
         * @param {OpsCreateRelativeRequestDto} opsCreateRelativeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeForProbandFromOrderProgressionController: function (probandId, opsCreateRelativeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRelativeForProbandFromOrderProgressionController(probandId, opsCreateRelativeRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an indication for a relative
         * @param {number} relativeId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeIndicationFromOrderProgressionController: function (relativeId, opsCreateIndicationRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRelativeIndicationFromOrderProgressionController(relativeId, opsCreateIndicationRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
         * @summary Finalizes the derived models for a requisition
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRqConfirmDerivedModelsFromOrderProgressionController: function (rqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRqConfirmDerivedModelsFromOrderProgressionController(rqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
         * @summary PUBLISH a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publishPolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an indication attribute
         * @param {number} attributeId
         * @param {OpsUpdateIndicationAttributeRequestObjectDto} opsUpdateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationAttributeFromOrderProgressionController: function (attributeId, opsUpdateIndicationAttributeRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putIndicationAttributeFromOrderProgressionController(attributeId, opsUpdateIndicationAttributeRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an indication
         * @param {number} indicationId
         * @param {OpsUpdateIndicationRequestObjectDto} opsUpdateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationFromOrderProgressionController: function (indicationId, opsUpdateIndicationRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putIndicationFromOrderProgressionController(indicationId, opsUpdateIndicationRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
         * @summary Un-archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchivePolicyFromOrderProgressionController: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unarchivePolicyFromOrderProgressionController(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates a policy and returns the updated policy
         * @summary Updates a policy given the request object data
         * @param {number} policyId
         * @param {OpsUpdatePolicyRequestObjectDto} opsUpdatePolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyFromOrderProgressionController: function (policyId, opsUpdatePolicyRequestObjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePolicyFromOrderProgressionController(policyId, opsUpdatePolicyRequestObjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrderProgressionApiFp = OrderProgressionApiFp;
/**
 * OrderProgressionApi - factory interface
 * @export
 */
var OrderProgressionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrderProgressionApiFp)(configuration);
    return {
        /**
         * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
         * @summary Archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.archivePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a new draft of the policy
         * @summary Creates a new version in draft mode from a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDraftPolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.cloneDraftPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Confirms the indication and its attributes
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmIndicationFromOrderProgressionController: function (indicationId, options) {
            return localVarFp.confirmIndicationFromOrderProgressionController(indicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Confirms the relative and child models
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRelativeFromOrderProgressionController: function (relativeId, options) {
            return localVarFp.confirmRelativeFromOrderProgressionController(relativeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {OpsNewAttributeConfigRequestObjectDto} opsNewAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributeConfigFromOrderProgressionController: function (opsNewAttributeConfigRequestObjectDto, options) {
            return localVarFp.createAttributeConfigFromOrderProgressionController(opsNewAttributeConfigRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {OpsNewIndicationConfigRequestObjectDto} opsNewIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndicationConfigFromOrderProgressionController: function (opsNewIndicationConfigRequestObjectDto, options) {
            return localVarFp.createIndicationConfigFromOrderProgressionController(opsNewIndicationConfigRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new policy record for meeting medical necessity
         * @summary Creates a new policy
         * @param {OpsNewPolicyRequestObjectDto} opsNewPolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyFromOrderProgressionController: function (opsNewPolicyRequestObjectDto, options) {
            return localVarFp.createPolicyFromOrderProgressionController(opsNewPolicyRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a new rule for the given policy
         * @summary Creates a new rule for a policy
         * @param {number} policyId
         * @param {OpsNewRuleRequestObjectDto} opsNewRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyRuleFromOrderProgressionController: function (policyId, opsNewRuleRequestObjectDto, options) {
            return localVarFp.createPolicyRuleFromOrderProgressionController(policyId, opsNewRuleRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an indication attribute configuration
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            return localVarFp.deleteAttributeConfigFromOrderProgressionController(attributeConfigId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an indication attribute
         * @param {number} attributeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationAttributeFromOrderProgressionController: function (attributeId, options) {
            return localVarFp.deleteIndicationAttributeFromOrderProgressionController(attributeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an indication configuration
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            return localVarFp.deleteIndicationConfigFromOrderProgressionController(indicationConfigId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an indication
         * @param {number} indicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndicationFromOrderProgressionController: function (indicationId, options) {
            return localVarFp.deleteIndicationFromOrderProgressionController(indicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This deletes the policy is_draft=True, is_active=False
         * @summary DELETES a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.deletePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a relative by id
         * @param {number} relativeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelativeFromOrderProgressionController: function (relativeId, options) {
            return localVarFp.deleteRelativeFromOrderProgressionController(relativeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} force
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRqFromOrderProgressionController: function (rqid, force, options) {
            return localVarFp.deleteRqFromOrderProgressionController(rqid, force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a medical necessity rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleFromOrderProgressionController: function (ruleId, options) {
            return localVarFp.deleteRuleFromOrderProgressionController(ruleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a indication attribute configuration by id
         * @param {number} attributeConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigFromOrderProgressionController: function (attributeConfigId, options) {
            return localVarFp.getAttributeConfigFromOrderProgressionController(attributeConfigId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available indications attribute definitions
         * @summary Returns a list indication attribute configurations for the indication
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return localVarFp.getAttributeConfigsFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of available cpts for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCptsFromOrderProgressionController: function (options) {
            return localVarFp.getCptsFromOrderProgressionController(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a indication configuration by id
         * @param {number} indicationConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigFromOrderProgressionController: function (indicationConfigId, options) {
            return localVarFp.getIndicationConfigFromOrderProgressionController(indicationConfigId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list indication names with configurations
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return localVarFp.getIndicationConfigsFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of indications with matching names, and a list of options with matching option names
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndicationConfigsWithRelatedOptionsFromOrderProgressionController: function (query, options) {
            return localVarFp.getIndicationConfigsWithRelatedOptionsFromOrderProgressionController(query, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the most recently edited timestamps and user emails.
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEditorsFromOrderProgressionController: function (rqid, options) {
            return localVarFp.getLastEditorsFromOrderProgressionController(rqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a medical necessity rule given an id
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalNecessityRuleFromOrderProgressionController: function (ruleId, options) {
            return localVarFp.getMedicalNecessityRuleFromOrderProgressionController(ruleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
         * @summary Returns a list of policies along with the pagination info for the query
         * @param {number} [page] the page to request, defaulted to 1
         * @param {number} [limit] number of records to return per request, defaulted to 50
         * @param {string} [filters] filters should be a comma separated string of key:values definitions
         * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoliciesFromOrderProgressionController: function (page, limit, filters, orderBy, options) {
            return localVarFp.getPoliciesFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.getPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of available primary indication names used by backoffice/portal
         * @summary Returns a list of primary indications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryIndicationNamesFromOrderProgressionController: function (options) {
            return localVarFp.getPrimaryIndicationNamesFromOrderProgressionController(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns lineage options and relationship type options with configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelativeConfigsFromOrderProgressionController: function (options) {
            return localVarFp.getRelativeConfigsFromOrderProgressionController(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Requisition by ReqRepo Requisition Id
         * @param {number} rqid
         * @param {string} [plan]
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [userEmail] the email of the user that initially loaded in the Requisition or the last user to edit anything related
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqFromOrderProgressionController: function (rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options) {
            return localVarFp.getRqFromOrderProgressionController(rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns an LMN generated attachment object model for an rq given a met rule id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqLmnAttachmentForMetRuleFromOrderProgressionController: function (id, options) {
            return localVarFp.getRqLmnAttachmentForMetRuleFromOrderProgressionController(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
         * @summary Returns a satisfied policy for the given requisition\'s current state, if one exists
         * @param {number} id
         * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRqSatisfiedPolicyFromOrderProgressionController: function (id, useInsurancePolicies, options) {
            return localVarFp.getRqSatisfiedPolicyFromOrderProgressionController(id, useInsurancePolicies, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new indication attribute for medical necessity review
         * @summary Create a new indication attribute configuration
         * @param {number} attributeConfigId
         * @param {OpsPatchAttributeConfigRequestObjectDto} opsPatchAttributeConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAttributeConfigFromOrderProgressionController: function (attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options) {
            return localVarFp.patchAttributeConfigFromOrderProgressionController(attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new indication for medical necessity review
         * @summary Create a new indication configuration
         * @param {number} indicationConfigId
         * @param {OpsPatchIndicationConfigRequestObjectDto} opsPatchIndicationConfigRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIndicationConfigFromOrderProgressionController: function (indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options) {
            return localVarFp.patchIndicationConfigFromOrderProgressionController(indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Patch a proband
         * @param {number} probandId
         * @param {OpsPatchProbandRequestObjectDto} opsPatchProbandRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProbandFromOrderProgressionController: function (probandId, opsPatchProbandRequestObjectDto, options) {
            return localVarFp.patchProbandFromOrderProgressionController(probandId, opsPatchProbandRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary answer a planner question, patches requisition object
         * @param {number} id
         * @param {OpsQuestionAnswerRequestDto} opsQuestionAnswerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionAnswerFromOrderProgressionController: function (id, opsQuestionAnswerRequestDto, options) {
            return localVarFp.patchQuestionAnswerFromOrderProgressionController(id, opsQuestionAnswerRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Patch a relative
         * @param {number} relativeId
         * @param {OpsPatchRelativeRequestObjectDto} opsPatchRelativeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRelativeFromOrderProgressionController: function (relativeId, opsPatchRelativeRequestObjectDto, options) {
            return localVarFp.patchRelativeFromOrderProgressionController(relativeId, opsPatchRelativeRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
         * @summary Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqCheckForUpdatesFromOrderProgressionController: function (id, options) {
            return localVarFp.patchRqCheckForUpdatesFromOrderProgressionController(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
         * @param {number} id
         * @param {OpsPatchRequisitionRequestDto} opsPatchRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRqFromOrderProgressionController: function (id, opsPatchRequisitionRequestDto, options) {
            return localVarFp.patchRqFromOrderProgressionController(id, opsPatchRequisitionRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
         * @summary Patches a medical necessity rule and relational definitions
         * @param {number} ruleId
         * @param {OpsPatchRuleRequestObjectDto} opsPatchRuleRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRuleFromOrderProgressionController: function (ruleId, opsPatchRuleRequestObjectDto, options) {
            return localVarFp.patchRuleFromOrderProgressionController(ruleId, opsPatchRuleRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new attribute for an indication
         * @param {number} indicationId
         * @param {OpsCreateIndicationAttributeRequestObjectDto} opsCreateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIndicationAttributeFromOrderProgressionController: function (indicationId, opsCreateIndicationAttributeRequestObjectDto, options) {
            return localVarFp.postIndicationAttributeFromOrderProgressionController(indicationId, opsCreateIndicationAttributeRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an indication for a proband
         * @param {number} probandId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProbandIndicationFromOrderProgressionController: function (probandId, opsCreateIndicationRequestObjectDto, options) {
            return localVarFp.postProbandIndicationFromOrderProgressionController(probandId, opsCreateIndicationRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new relative for a proband
         * @param {number} probandId
         * @param {OpsCreateRelativeRequestDto} opsCreateRelativeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeForProbandFromOrderProgressionController: function (probandId, opsCreateRelativeRequestDto, options) {
            return localVarFp.postRelativeForProbandFromOrderProgressionController(probandId, opsCreateRelativeRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an indication for a relative
         * @param {number} relativeId
         * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelativeIndicationFromOrderProgressionController: function (relativeId, opsCreateIndicationRequestObjectDto, options) {
            return localVarFp.postRelativeIndicationFromOrderProgressionController(relativeId, opsCreateIndicationRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
         * @summary Finalizes the derived models for a requisition
         * @param {number} rqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRqConfirmDerivedModelsFromOrderProgressionController: function (rqid, options) {
            return localVarFp.postRqConfirmDerivedModelsFromOrderProgressionController(rqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
         * @summary PUBLISH a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.publishPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an indication attribute
         * @param {number} attributeId
         * @param {OpsUpdateIndicationAttributeRequestObjectDto} opsUpdateIndicationAttributeRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationAttributeFromOrderProgressionController: function (attributeId, opsUpdateIndicationAttributeRequestObjectDto, options) {
            return localVarFp.putIndicationAttributeFromOrderProgressionController(attributeId, opsUpdateIndicationAttributeRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an indication
         * @param {number} indicationId
         * @param {OpsUpdateIndicationRequestObjectDto} opsUpdateIndicationRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIndicationFromOrderProgressionController: function (indicationId, opsUpdateIndicationRequestObjectDto, options) {
            return localVarFp.putIndicationFromOrderProgressionController(indicationId, opsUpdateIndicationRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
         * @summary Un-archives a given policy
         * @param {number} policyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchivePolicyFromOrderProgressionController: function (policyId, options) {
            return localVarFp.unarchivePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates a policy and returns the updated policy
         * @summary Updates a policy given the request object data
         * @param {number} policyId
         * @param {OpsUpdatePolicyRequestObjectDto} opsUpdatePolicyRequestObjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyFromOrderProgressionController: function (policyId, opsUpdatePolicyRequestObjectDto, options) {
            return localVarFp.updatePolicyFromOrderProgressionController(policyId, opsUpdatePolicyRequestObjectDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrderProgressionApiFactory = OrderProgressionApiFactory;
/**
 * OrderProgressionApi - object-oriented interface
 * @export
 * @class OrderProgressionApi
 * @extends {BaseAPI}
 */
var OrderProgressionApi = /** @class */ (function (_super) {
    __extends(OrderProgressionApi, _super);
    function OrderProgressionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
     * @summary Archives a given policy
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.archivePolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).archivePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a new draft of the policy
     * @summary Creates a new version in draft mode from a given policy
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.cloneDraftPolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).cloneDraftPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Confirms the indication and its attributes
     * @param {number} indicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.confirmIndicationFromOrderProgressionController = function (indicationId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).confirmIndicationFromOrderProgressionController(indicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Confirms the relative and child models
     * @param {number} relativeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.confirmRelativeFromOrderProgressionController = function (relativeId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).confirmRelativeFromOrderProgressionController(relativeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * @summary Create a new indication attribute configuration
     * @param {OpsNewAttributeConfigRequestObjectDto} opsNewAttributeConfigRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.createAttributeConfigFromOrderProgressionController = function (opsNewAttributeConfigRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).createAttributeConfigFromOrderProgressionController(opsNewAttributeConfigRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new indication for medical necessity review
     * @summary Create a new indication configuration
     * @param {OpsNewIndicationConfigRequestObjectDto} opsNewIndicationConfigRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.createIndicationConfigFromOrderProgressionController = function (opsNewIndicationConfigRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).createIndicationConfigFromOrderProgressionController(opsNewIndicationConfigRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new policy record for meeting medical necessity
     * @summary Creates a new policy
     * @param {OpsNewPolicyRequestObjectDto} opsNewPolicyRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.createPolicyFromOrderProgressionController = function (opsNewPolicyRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).createPolicyFromOrderProgressionController(opsNewPolicyRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a new rule for the given policy
     * @summary Creates a new rule for a policy
     * @param {number} policyId
     * @param {OpsNewRuleRequestObjectDto} opsNewRuleRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.createPolicyRuleFromOrderProgressionController = function (policyId, opsNewRuleRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).createPolicyRuleFromOrderProgressionController(policyId, opsNewRuleRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an indication attribute configuration
     * @param {number} attributeConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteAttributeConfigFromOrderProgressionController = function (attributeConfigId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteAttributeConfigFromOrderProgressionController(attributeConfigId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an indication attribute
     * @param {number} attributeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteIndicationAttributeFromOrderProgressionController = function (attributeId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteIndicationAttributeFromOrderProgressionController(attributeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an indication configuration
     * @param {number} indicationConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteIndicationConfigFromOrderProgressionController = function (indicationConfigId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteIndicationConfigFromOrderProgressionController(indicationConfigId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an indication
     * @param {number} indicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteIndicationFromOrderProgressionController = function (indicationId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteIndicationFromOrderProgressionController(indicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This deletes the policy is_draft=True, is_active=False
     * @summary DELETES a given policy
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deletePolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deletePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a relative by id
     * @param {number} relativeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteRelativeFromOrderProgressionController = function (relativeId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteRelativeFromOrderProgressionController(relativeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Requisition by ReqRepo Requisition Id
     * @param {number} rqid
     * @param {string} force
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteRqFromOrderProgressionController = function (rqid, force, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteRqFromOrderProgressionController(rqid, force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a medical necessity rule
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.deleteRuleFromOrderProgressionController = function (ruleId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).deleteRuleFromOrderProgressionController(ruleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a indication attribute configuration by id
     * @param {number} attributeConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getAttributeConfigFromOrderProgressionController = function (attributeConfigId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getAttributeConfigFromOrderProgressionController(attributeConfigId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available indications attribute definitions
     * @summary Returns a list indication attribute configurations for the indication
     * @param {number} [page] the page to request, defaulted to 1
     * @param {number} [limit] number of records to return per request, defaulted to 50
     * @param {string} [filters] filters should be a comma separated string of key:values definitions
     * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getAttributeConfigsFromOrderProgressionController = function (page, limit, filters, orderBy, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getAttributeConfigsFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of available cpts for billing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getCptsFromOrderProgressionController = function (options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getCptsFromOrderProgressionController(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a indication configuration by id
     * @param {number} indicationConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getIndicationConfigFromOrderProgressionController = function (indicationConfigId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getIndicationConfigFromOrderProgressionController(indicationConfigId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list indication names with configurations
     * @param {number} [page] the page to request, defaulted to 1
     * @param {number} [limit] number of records to return per request, defaulted to 50
     * @param {string} [filters] filters should be a comma separated string of key:values definitions
     * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getIndicationConfigsFromOrderProgressionController = function (page, limit, filters, orderBy, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getIndicationConfigsFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of indications with matching names, and a list of options with matching option names
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getIndicationConfigsWithRelatedOptionsFromOrderProgressionController = function (query, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getIndicationConfigsWithRelatedOptionsFromOrderProgressionController(query, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the most recently edited timestamps and user emails.
     * @param {number} rqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getLastEditorsFromOrderProgressionController = function (rqid, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getLastEditorsFromOrderProgressionController(rqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a medical necessity rule given an id
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getMedicalNecessityRuleFromOrderProgressionController = function (ruleId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getMedicalNecessityRuleFromOrderProgressionController(ruleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
     * @summary Returns a list of policies along with the pagination info for the query
     * @param {number} [page] the page to request, defaulted to 1
     * @param {number} [limit] number of records to return per request, defaulted to 50
     * @param {string} [filters] filters should be a comma separated string of key:values definitions
     * @param {string} [orderBy] order_by should be a comma separated str, if asc/desc not provided we default to asc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getPoliciesFromOrderProgressionController = function (page, limit, filters, orderBy, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getPoliciesFromOrderProgressionController(page, limit, filters, orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
     * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getPolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of available primary indication names used by backoffice/portal
     * @summary Returns a list of primary indications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getPrimaryIndicationNamesFromOrderProgressionController = function (options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getPrimaryIndicationNamesFromOrderProgressionController(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns lineage options and relationship type options with configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getRelativeConfigsFromOrderProgressionController = function (options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getRelativeConfigsFromOrderProgressionController(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Requisition by ReqRepo Requisition Id
     * @param {number} rqid
     * @param {string} [plan]
     * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
     * @param {string} [userEmail] the email of the user that initially loaded in the Requisition or the last user to edit anything related
     * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getRqFromOrderProgressionController = function (rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getRqFromOrderProgressionController(rqid, plan, allowUnconfirmedFields, userEmail, useInsurancePolicies, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns an LMN generated attachment object model for an rq given a met rule id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getRqLmnAttachmentForMetRuleFromOrderProgressionController = function (id, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getRqLmnAttachmentForMetRuleFromOrderProgressionController(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
     * @summary Returns a satisfied policy for the given requisition\'s current state, if one exists
     * @param {number} id
     * @param {string} [useInsurancePolicies] whether to use insurance policies or non-insurance policies to meet mn, defaults to true
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.getRqSatisfiedPolicyFromOrderProgressionController = function (id, useInsurancePolicies, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).getRqSatisfiedPolicyFromOrderProgressionController(id, useInsurancePolicies, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * @summary Create a new indication attribute configuration
     * @param {number} attributeConfigId
     * @param {OpsPatchAttributeConfigRequestObjectDto} opsPatchAttributeConfigRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchAttributeConfigFromOrderProgressionController = function (attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchAttributeConfigFromOrderProgressionController(attributeConfigId, opsPatchAttributeConfigRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new indication for medical necessity review
     * @summary Create a new indication configuration
     * @param {number} indicationConfigId
     * @param {OpsPatchIndicationConfigRequestObjectDto} opsPatchIndicationConfigRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchIndicationConfigFromOrderProgressionController = function (indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchIndicationConfigFromOrderProgressionController(indicationConfigId, opsPatchIndicationConfigRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Patch a proband
     * @param {number} probandId
     * @param {OpsPatchProbandRequestObjectDto} opsPatchProbandRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchProbandFromOrderProgressionController = function (probandId, opsPatchProbandRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchProbandFromOrderProgressionController(probandId, opsPatchProbandRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary answer a planner question, patches requisition object
     * @param {number} id
     * @param {OpsQuestionAnswerRequestDto} opsQuestionAnswerRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchQuestionAnswerFromOrderProgressionController = function (id, opsQuestionAnswerRequestDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchQuestionAnswerFromOrderProgressionController(id, opsQuestionAnswerRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Patch a relative
     * @param {number} relativeId
     * @param {OpsPatchRelativeRequestObjectDto} opsPatchRelativeRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchRelativeFromOrderProgressionController = function (relativeId, opsPatchRelativeRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchRelativeFromOrderProgressionController(relativeId, opsPatchRelativeRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
     * @summary Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchRqCheckForUpdatesFromOrderProgressionController = function (id, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchRqCheckForUpdatesFromOrderProgressionController(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
     * @param {number} id
     * @param {OpsPatchRequisitionRequestDto} opsPatchRequisitionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchRqFromOrderProgressionController = function (id, opsPatchRequisitionRequestDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchRqFromOrderProgressionController(id, opsPatchRequisitionRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
     * @summary Patches a medical necessity rule and relational definitions
     * @param {number} ruleId
     * @param {OpsPatchRuleRequestObjectDto} opsPatchRuleRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.patchRuleFromOrderProgressionController = function (ruleId, opsPatchRuleRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).patchRuleFromOrderProgressionController(ruleId, opsPatchRuleRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new attribute for an indication
     * @param {number} indicationId
     * @param {OpsCreateIndicationAttributeRequestObjectDto} opsCreateIndicationAttributeRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.postIndicationAttributeFromOrderProgressionController = function (indicationId, opsCreateIndicationAttributeRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).postIndicationAttributeFromOrderProgressionController(indicationId, opsCreateIndicationAttributeRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an indication for a proband
     * @param {number} probandId
     * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.postProbandIndicationFromOrderProgressionController = function (probandId, opsCreateIndicationRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).postProbandIndicationFromOrderProgressionController(probandId, opsCreateIndicationRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new relative for a proband
     * @param {number} probandId
     * @param {OpsCreateRelativeRequestDto} opsCreateRelativeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.postRelativeForProbandFromOrderProgressionController = function (probandId, opsCreateRelativeRequestDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).postRelativeForProbandFromOrderProgressionController(probandId, opsCreateRelativeRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an indication for a relative
     * @param {number} relativeId
     * @param {OpsCreateIndicationRequestObjectDto} opsCreateIndicationRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.postRelativeIndicationFromOrderProgressionController = function (relativeId, opsCreateIndicationRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).postRelativeIndicationFromOrderProgressionController(relativeId, opsCreateIndicationRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
     * @summary Finalizes the derived models for a requisition
     * @param {number} rqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.postRqConfirmDerivedModelsFromOrderProgressionController = function (rqid, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).postRqConfirmDerivedModelsFromOrderProgressionController(rqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
     * @summary PUBLISH a given policy
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.publishPolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).publishPolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an indication attribute
     * @param {number} attributeId
     * @param {OpsUpdateIndicationAttributeRequestObjectDto} opsUpdateIndicationAttributeRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.putIndicationAttributeFromOrderProgressionController = function (attributeId, opsUpdateIndicationAttributeRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).putIndicationAttributeFromOrderProgressionController(attributeId, opsUpdateIndicationAttributeRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an indication
     * @param {number} indicationId
     * @param {OpsUpdateIndicationRequestObjectDto} opsUpdateIndicationRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.putIndicationFromOrderProgressionController = function (indicationId, opsUpdateIndicationRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).putIndicationFromOrderProgressionController(indicationId, opsUpdateIndicationRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
     * @summary Un-archives a given policy
     * @param {number} policyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.unarchivePolicyFromOrderProgressionController = function (policyId, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).unarchivePolicyFromOrderProgressionController(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates a policy and returns the updated policy
     * @summary Updates a policy given the request object data
     * @param {number} policyId
     * @param {OpsUpdatePolicyRequestObjectDto} opsUpdatePolicyRequestObjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProgressionApi
     */
    OrderProgressionApi.prototype.updatePolicyFromOrderProgressionController = function (policyId, opsUpdatePolicyRequestObjectDto, options) {
        var _this = this;
        return (0, exports.OrderProgressionApiFp)(this.configuration).updatePolicyFromOrderProgressionController(policyId, opsUpdatePolicyRequestObjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrderProgressionApi;
}(base_1.BaseAPI));
exports.OrderProgressionApi = OrderProgressionApi;
